import { useContext, useEffect, useState } from 'react'
import useDebouncedValue from '../../../utils/common_function'
import { getRequest } from '../../../services/base'
import InputText from '../../common/InputText'
import CheckBox from '../../common/CheckBox'
import Button from '../../common/Button'
import { NavContext } from '../../../context/global_context'
import SelectVersionModal from './SelectVerionModal'
import { PromotedBranchContext } from '../context/context'

const SelectMakeModelModal = () => {
  const [state, dispatch] = useContext(PromotedBranchContext)

  const [searchVehicles, setSearchVehicles] = useState('')
  const [selectedVehicle, setSelectedVehicle] = useState(null)
  const debouncedToSearchVehicles = useDebouncedValue(searchVehicles, 1000)

  const [vehiclesList, setVehiclesList] = useState([])
  const [selectTracerVersion, setSelectTracerVersion] = useState(false)

  useEffect(() => {
    getVehiclesList()
  }, [])

  const getVehiclesList = async (search = '') => {
    let res = await getRequest(`/api/vehicles/?search=${search}&limit=25`)
    setVehiclesList(res?.results)
  }

  useEffect(() => {
    getVehiclesList(searchVehicles)
  }, [debouncedToSearchVehicles])

  return selectedVehicle?.name && selectTracerVersion ? (
    <>
      <SelectVersionModal
        vehicle={selectedVehicle?.vehicle_id}
        setSelectTracerVersion={setSelectTracerVersion}
      />
    </>
  ) : (
    <>
      <div className="flex items-center text-base justify-between">
        <InputText
          name="search_value"
          placeholder={`Search Make Model`}
          className={`w-full`}
          value={searchVehicles}
          isFullSize={true}
          type="search"
          onChange={(value) => {
            setSearchVehicles(value)
          }}
          isRequired={false}
          wrapperClass={`pl-0`}
        />
      </div>

      <div className="flex flex-row flex-wrap text-white text-lg">
        {vehiclesList?.map((vehicle, vehicleIdx) => {
          return (
            <div className="flex w-1/4" key={`vehicle-${vehicleIdx}`}>
              <div className={`px-2 flex table_text`}>
                <CheckBox
                  onChange={(e) => {
                    setSelectedVehicle(vehicle)
                  }}
                  checked={selectedVehicle?.vehicle_id === vehicle?.vehicle_id}
                />
                <span className="px-2">
                  {vehicle.name} ({vehicle.make_model_id})
                </span>
              </div>
            </div>
          )
        })}
      </div>
      {selectedVehicle?.name && (
        <div className="flex flex-row pt-4 items-center justify-end">
          <Button
            type="submit"
            className={`cursor-pointer btn`}
            text={`Run Preview for ${selectedVehicle?.name}`}
            onClick={() => {
              //   RunTracerPreview()
              setSelectTracerVersion(true)
              dispatch({
                type: 'set_tracer_preview_data',
                data: { vehicle: selectedVehicle },
              })
            }}
          />
        </div>
      )}
    </>
  )
}

export default SelectMakeModelModal
